import script from "./PassportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PassportTable.vue?vue&type=script&setup=true&lang=js"

import "./PassportTable.vue?vue&type=style&index=0&id=4d5a4605&scoped=true&lang=scss"
import "./PassportTable.vue?vue&type=style&index=1&id=4d5a4605&lang=css"
script.__scopeId = "data-v-4d5a4605"

export default script